export default __webpack_public_path__ + "static/media/Neddie-Screen-5.fadab564.png";